const FIELD_OPTIONS = [
  { key: "bedrijfsnaam", required: true },
  { key: "klantnummer", required: false },
  { key: "status", required: false },
  { key: "bezoekadres", required: false },
  { key: "factuuradres", required: false },
  { key: "kvk", required: false },
  { key: "btw", required: false },
  { key: "hoofdcontactpersoon", required: false },
  { key: "telefoon", required: false },
  { key: "email", required: false },
  { key: "klanttype", required: false },
];

export default function CustomerImportMappingStep({ headers, mapping, onChange, onPreview, loading, disabled }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="text-base font-semibold text-slate-900">2. Kolommen mappen</h3>
      <p className="mt-1 text-sm text-slate-500">Controleer of elke kolom goed is herkend.</p>

      <div className="mt-4 grid gap-3 md:grid-cols-2">
        {FIELD_OPTIONS.map((field) => (
          <label key={field.key} className="block">
            <span className="mb-1 block text-sm font-medium text-slate-700">
              {field.key}
              {field.required ? " *" : ""}
            </span>
            <select
              value={mapping[field.key] || ""}
              onChange={(event) => onChange(field.key, event.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
            >
              <option value="">-- niet koppelen --</option>
              {headers.map((header) => (
                <option key={header} value={header}>
                  {header}
                </option>
              ))}
            </select>
          </label>
        ))}
      </div>

      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={onPreview}
          disabled={loading || disabled}
          className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-60"
        >
          {loading ? "Preview laden..." : "Preview genereren"}
        </button>
      </div>
    </div>
  );
}
